import React from 'react'
import DataTableRow from './DataTableRow'

// Will output all rows for data table
const DataTableRows = ({
    data, colData, editRoute, colSortKey, colSortAsc
}) => {

    return (
        data.sort((first, second) => {
            if(first[colSortKey] > second[colSortKey]) return colSortAsc ? 1 : -1;
            if(first[colSortKey] < second[colSortKey]) return !colSortAsc ? 1 : -1;
            return 0;
        }).map((row, index) => (
            <tr key={index} className="clickable">

                {colData.map((col, colIndex) => (
                    <DataTableRow 
                        key={colIndex}
                        rowData={row}
                        column={col}
                        editRoute={editRoute}
                    />
                ))}

            </tr>
        ))
    )
}

export default DataTableRows


// WEBPACK FOOTER //
// ./src/components/utils/DataTable/DataTableRows.js